import {
  RequirementDefinition,
  RequirementExpirationStrategy
} from "@wingspanhq/wingspan-api-sdk";

import { BaseRequirementDefinitionFormValues } from "../types";

export const getBaseEditValues = (
  requirementDefinition: RequirementDefinition
): BaseRequirementDefinitionFormValues => ({
  description: requirementDefinition.description,
  expirationDays: requirementDefinition.expirationDays ?? 30,
  expirationStrategy:
    requirementDefinition.expirationStrategy ??
    RequirementExpirationStrategy.NONE,
  isApprovalRequired: requirementDefinition.reviewPolicy !== "NeverRequired",
  manualRenewalAllowed: requirementDefinition.manualRenewalAllowed ?? false,
  name: requirementDefinition.name!,
  reviewStrategy: requirementDefinition.reviewPolicy,
  type: requirementDefinition.type!
});
